module.exports = __webpack_public_path__ + "img/553.4e35c804.jpg";